'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var BubbleItem = require('./BubbleItem.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const FlashingBubbleItems = ({ items, position }) => {
  const [index, setIndex] = React__default["default"].useState(0);
  const item = items[index];
  React.useEffect(() => {
    const interval = setInterval(() => {
      setIndex((index + 1) % items.length);
    }, 1e3);
    return () => clearInterval(interval);
  }, [index, items.length]);
  return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /* @__PURE__ */ jsxRuntime.jsx(BubbleItem.BubbleItem, {
      item,
      position
    })
  });
};

exports.FlashingBubbleItems = FlashingBubbleItems;
